module.exports = __webpack_public_path__ + "videos/sync-translation.d359362.mp4";